import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {
  Container,
  Button,
  Row,
  Col,
  Table,
  Form,
  Spinner,
} from "react-bootstrap";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

import { API_URL } from "../utils/config";
const UserFragment = () => {
  const [courses, setCourses] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    type: "admin",
    company: "",
    companies: [], // Array for multiple schools
    city: "",
    state: "",
    permissions: [],
  });
  const [isEdit, setIsEdit] = useState(false);
  const [cities, setCities] = useState([]); // List of unique cities
  const [states, setStates] = useState([]); // List of unique states

  useEffect(() => {
    fetchCompanies();
    // extractCitiesAndStates();
  }, []);

  useEffect(() => {
    if (companies.length > 0) {
      extractCitiesAndStates();
    }
  }, [companies]);

  useEffect(() => {
    fetchUsers(currentPage);
  }, [currentPage]);

  // Extract unique cities and states from companies
  const extractCitiesAndStates = () => {
    const uniqueCities = [...new Set(companies.map((company) => company.city))]
      .filter(Boolean)
      .sort();

    const uniqueStates = [
      ...new Set(companies.map((company) => company.country)),
    ]
      .filter(Boolean)
      .sort();

    setCities(uniqueCities);
    setStates(uniqueStates);

    console.log("Extracted cities:", uniqueCities);
    console.log("Extracted states:", uniqueStates);
  };

  const fetchUsers = async (page) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let apiUrl = `${API_URL}/admin/all-users?page=${currentPage}&pageSize=10`;
    fetch(apiUrl, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setCourses(result.users);
        setTotalPage(result.totalPages);
      })
      .catch((error) => console.error(error));
  };

  const fetchCompanies = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", localStorage.getItem("token"));
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(`${API_URL}/admin/companies`, requestOptions)
      .then((response) => {
        if (response.status == 401) {
          localStorage.clear();
          window.location.reload();
          return [];
        } else {
          return response.json();
        }
      })
      .then((result) => {
        console.log("Companies fetched:", result);
        setCompanies(result);

        // Extract cities and states here to ensure they're populated
        const uniqueCities = [...new Set(result.map((company) => company.city))]
          .filter(Boolean)
          .sort();

        const uniqueStates = [
          ...new Set(result.map((company) => company.country)),
        ]
          .filter(Boolean)
          .sort();

        console.log("Extracted cities:", uniqueCities);
        console.log("Extracted states:", uniqueStates);

        setCities(uniqueCities);
        setStates(uniqueStates);
      })
      .catch((error) => console.error(error));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.type === "admin" && formData.companies.length === 0) {
      alert("Please select at least one school for the admin.");
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      myHeaders.append("Content-Type", "application/json");

      // Set default permissions based on user type
      let permissions = [];
      if (formData.type === "bcom") {
        permissions = formData.permissions;
      } else if (
        ["admin", "city_manager", "state_manager"].includes(formData.type)
      ) {
        // School admin, city manager, and state manager should only have dashboard permission
        permissions = ["dashboard"];
      }
      if (formData.type === "query_manager") {
        permissions = ["query"];
      }
      // Prepare request body based on user type
      let requestBody = {
        username: formData.email,
        type: formData.type,
        permissions: permissions,
      };

      // Add fields based on user type
      if (formData.type === "admin") {
        requestBody.company = formData.company || null;
        requestBody.companies = formData.companies || [];
      } else if (formData.type === "city_manager") {
        requestBody.city = formData.city;
      } else if (formData.type === "state_manager") {
        requestBody.state = formData.state;
      }

      const raw = JSON.stringify(requestBody);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        `${API_URL}/admin/register-user`,
        requestOptions
      )
        .then((response) => {
          if (!response.ok) {
            alert("Failed to create user, please try again!!");
            throw new Error("Failed to upload user");
          } else {
            alert("User created successfully!!");
          }
        })
        .catch((error) => console.error(error));
      fetchUsers();
      setIsLoading(false);
      setFormData({
        email: "",
        type: "admin",
        company: "",
        companies: [],
        city: "",
        state: "",
        permissions: [],
      });
    } catch (error) {
      alert("Failed to create user, please try again!!");
      setIsLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", localStorage.getItem("token"));
      myHeaders.append("Content-Type", "application/json");

      // Set default permissions based on user type
      let permissions = [];
      if (formData.type === "bcom") {
        permissions = formData.permissions;
      } else if (
        ["admin", "city_manager", "state_manager"].includes(formData.type)
      ) {
        // School admin, city manager, and state manager should only have dashboard permission
        permissions = ["dashboard"];
      }
      if (formData.type === "query_manager") {
        permissions = ["query"];
      }

      // Prepare request body based on user type
      let requestBody = {
        username: formData.email,
        type: formData.type,
        permissions: permissions,
      };

      // Add fields based on user type
      if (formData.type === "admin") {
        requestBody.company = formData.company || null;
        requestBody.companies = formData.companies || [];
      } else if (formData.type === "city_manager") {
        requestBody.city = formData.city;
      } else if (formData.type === "state_manager") {
        requestBody.state = formData.state;
      }

      const raw = JSON.stringify(requestBody);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${API_URL}/admin/users/${formData.usesrIdToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error("Failed to update user");
      }
      setFormData({
        email: "",
        type: "admin",
        company: "",
        companies: [],
        city: "",
        state: "",
        permissions: [],
      });
      alert("User updated successfully!");
      fetchUsers();
      setIsEdit(false);
      setIsLoading(false);
    } catch (error) {
      console.log();
      alert("Failed to update user, please try again!");
      setIsLoading(false);
    }
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, thumbnail: e.target.files[0] });
  };

  const handleEdit = (course) => {
    setFormData({
      usesrIdToUpdate: course._id,
      email: course.username,
      type: course.type,
      company: course.type === "admin" ? course.company?._id : null,
      companies: course.companies?.map((comp) => comp._id) || [],
      city: course.city || "",
      state: course.state || "",
      permissions: course.permissions || [],
    });
    setIsEdit(true);
  };

  const handleDelete = async (userID) => {
    // Display confirmation popup before deleting
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!isConfirmed) return; // If user cancels, do nothing

    try {
      const token = localStorage.getItem("token"); // Get the authentication token
      const requestOptions = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: token },
      };

      const response = await fetch(
        `${API_URL}/admin/delete-user/${userID}`,
        requestOptions
      );

      if (response.ok) {
        alert("User deleted successfully");
        fetchUsers();
      } else {
        alert("Failed to delete user");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user");
    }
  };

  // Function to handle changes in permissions
  const handlePermissionsChange = (e) => {
    const { value } = e.target;
    let updatedPermissions = [...formData.permissions];

    if (updatedPermissions.includes(value)) {
      updatedPermissions = updatedPermissions.filter(
        (permission) => permission !== value
      );
    } else {
      updatedPermissions.push(value);
    }

    setFormData({ ...formData, permissions: updatedPermissions });
  };

  // Function to handle multiple schools selection
  const handleMultipleSchoolsChange = (e) => {
    const options = e.target.options;
    const selectedSchools = [];

    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selectedSchools.push(options[i].value);
      }
    }

    setFormData({ ...formData, companies: selectedSchools });
  };

  function capitalizePermissions(permissions) {
    return permissions.map((permission) => {
      return " " + permission.charAt(0).toUpperCase() + permission.slice(1);
    });
  }

  // Function to get user type display text
  const getUserTypeDisplay = (type) => {
    switch (type) {
      case "admin":
        return "School Admin";
      case "city_manager":
        return "City Manager";
      case "state_manager":
        return "State Manager";
      case "bcom":
        return "BCOM Team";
      case "owner":
        return "School Owner";
      case "query_manager":
        return "Query Manager";
      default:
        return type;
    }
  };

  // Function to get user details based on type
  const getUserDetails = (user) => {
    if (user.type === "admin" || user.type === "owner") {
      let details = [];

      if (user.company) {
        details.push(user.company.name);
      }

      if (user.companies && user.companies.length > 0) {
        const additionalSchools = user.companies
          .filter((comp) => !user.company || comp._id !== user.company._id)
          .map((comp) => comp.name);

        if (additionalSchools.length > 0) {
          details.push(`Additional: ${additionalSchools.join(", ")}`);
        }
      }

      return details.join(", ") || "No schools assigned";
    } else if (user.type === "city_manager") {
      return `City: ${user.city || "Not assigned"}`;
    } else if (user.type === "state_manager") {
      return `State: ${user.state || "Not assigned"}`;
    } else if (user.type === "query_manager") {
      return "Query Manager";
    } else {
      return capitalizePermissions(user.permissions).toString();
    }
  };

  return (
    <Grid
      item
      xs={10}
      style={{
        padding: "20px",
        height: "100%",
        fontFamily: "Noto Sans",
        fontWeight: "500",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container fluid style={{ height: "100%" }}>
        <Row>
          <Col
            xs={8}
            style={{
              height: "90vh",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "start",
            }}
          >
            {courses.length > 0 ? (
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Type</th>
                    <th>Details</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Map through courses data to display each course */}
                  {courses.map((course) => (
                    <tr key={course._id}>
                      <td>{course.username}</td>
                      <td>{getUserTypeDisplay(course.type)}</td>
                      <td>{getUserDetails(course)}</td>
                      <td>
                        <EditNoteIcon
                          onClick={() => handleEdit(course)}
                          style={{ color: "green", cursor: "pointer" }}
                        />
                        <DeleteSweepIcon
                          onClick={() => handleDelete(course._id)}
                          style={{ color: "red", cursor: "pointer" }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={{ flex: 1, textAlign: "center" }}>
                No users found, please try again!
              </div>
            )}
            <div style={{ flex: 1 }}></div>
            <nav aria-label="Courses pagination">
              <ul className="pagination">
                {[...Array(totalPage).keys()].map((page) => (
                  <li
                    key={page}
                    className={`page-item ${
                      currentPage === page + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page + 1)}
                    >
                      {page + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </Col>
          {/* Form to Add a User (40% width) */}
          <Col xs={4}>
            <h4 style={{ marginTop: "15px" }}>
              {isEdit ? "Modify" : "Create"} User
            </h4>
            <Form
              style={{ fontFamily: "Noto Sans" }}
              className="w-100"
              onSubmit={isEdit ? handleUpdate : handleSubmit}
            >
              <Form.Group controlId="formEmail">
                <Form.Label style={{ fontWeight: "500", borderRadius: "20px" }}>
                  Email
                </Form.Label>
                <Form.Control
                  className="w-100"
                  style={{ width: "100%", borderRadius: "20px" }}
                  type="text"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />
              </Form.Group>
              <Form.Group
                controlId="formType"
                style={{
                  marginTop: "10px",
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Form.Label
                  style={{
                    fontWeight: "500",
                    borderRadius: "20px",
                    marginRight: "10px",
                  }}
                >
                  Type:
                </Form.Label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Form.Check
                    type="radio"
                    label="School Admin"
                    name="type"
                    value="admin"
                    checked={formData.type === "admin"}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    style={{ marginRight: "10px" }}
                  />
                  <Form.Check
                    type="radio"
                    label="City Manager"
                    name="type"
                    value="city_manager"
                    checked={formData.type === "city_manager"}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    style={{ marginRight: "10px" }}
                  />
                  <Form.Check
                    type="radio"
                    label="State Manager"
                    name="type"
                    value="state_manager"
                    checked={formData.type === "state_manager"}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    style={{ marginRight: "10px" }}
                  />
                  <Form.Check
                    type="radio"
                    label="BCOM Team"
                    name="type"
                    value="bcom"
                    checked={formData.type === "bcom"}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    style={{ marginRight: "10px" }}
                  />
                  <Form.Check
                    type="radio"
                    label="Query Manager"
                    name="type"
                    value="query_manager"
                    checked={formData.type === "query_manager"}
                    onChange={(e) =>
                      setFormData({ ...formData, type: e.target.value })
                    }
                    style={{ marginRight: "10px" }}
                  />
                </div>
              </Form.Group>

              {/* Conditional fields based on user type */}
              {formData.type === "admin" && (
                <Form.Group controlId="formSchools">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Select Schools
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "200px",
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: "10px",
                      padding: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {companies.map((company) => (
                      <Form.Check
                        key={company._id}
                        type="checkbox"
                        label={company.name}
                        value={company._id}
                        checked={formData.companies.includes(
                          company._id.toString()
                        )}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const value = e.target.value;
                          setFormData((prev) => {
                            let updated = [...prev.companies];
                            if (checked) {
                              if (!updated.includes(value)) updated.push(value);
                            } else {
                              updated = updated.filter((id) => id !== value);
                            }
                            return { ...prev, companies: updated };
                          });
                        }}
                        style={{ marginBottom: "5px" }}
                      />
                    ))}
                  </div>
                  <Form.Text className="text-muted">
                    Select one or more schools for this user.
                  </Form.Text>
                </Form.Group>
              )}

              {formData.type === "city_manager" && (
                <Form.Group controlId="formCity">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    City
                  </Form.Label>
                  <Form.Control
                    className="w-100"
                    style={{ width: "100%", borderRadius: "20px" }}
                    as="select"
                    value={formData.city}
                    onChange={(e) =>
                      setFormData({ ...formData, city: e.target.value })
                    }
                  >
                    <option value="">Select a city</option>
                    {cities.map((city, index) => (
                      <option key={index} value={city}>
                        {city}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}

              {formData.type === "state_manager" && (
                <Form.Group controlId="formState">
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    State
                  </Form.Label>
                  <Form.Control
                    className="w-100"
                    style={{ width: "100%", borderRadius: "20px" }}
                    as="select"
                    value={formData.state}
                    onChange={(e) =>
                      setFormData({ ...formData, state: e.target.value })
                    }
                  >
                    <option value="">Select a state</option>
                    {states.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              )}

              {formData.type === "bcom" && (
                <Form.Group
                  controlId="permissions"
                  style={{ marginTop: "10px" }}
                >
                  <Form.Label
                    style={{ fontWeight: "500", borderRadius: "20px" }}
                  >
                    Permissions:
                  </Form.Label>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gridColumnGap: "10px",
                    }}
                  >
                    <div>
                      <Form.Check
                        type="checkbox"
                        label="All"
                        name="permissions"
                        value="all"
                        checked={formData.permissions.includes("all")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Dashboard"
                        name="permissions"
                        value="dashboard"
                        checked={formData.permissions.includes("dashboard")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Students"
                        name="permissions"
                        value="employee"
                        checked={formData.permissions.includes("employee")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Course"
                        name="permissions"
                        value="course"
                        checked={formData.permissions.includes("course")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Quiz"
                        name="permissions"
                        value="quiz"
                        checked={formData.permissions.includes("quiz")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                    </div>
                    <div>
                      <Form.Check
                        type="checkbox"
                        label="Rating"
                        name="permissions"
                        value="rating"
                        checked={formData.permissions.includes("rating")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Answers"
                        name="permissions"
                        value="answers"
                        checked={formData.permissions.includes("answers")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Survey"
                        name="permissions"
                        value="survey"
                        checked={formData.permissions.includes("survey")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Info"
                        name="permissions"
                        value="info"
                        checked={formData.permissions.includes("info")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                      <Form.Check
                        type="checkbox"
                        label="Notification"
                        name="permissions"
                        value="notification"
                        checked={formData.permissions.includes("notification")}
                        onChange={(e) => handlePermissionsChange(e)}
                        style={{ marginTop: "5px" }}
                      />
                    </div>
                  </div>
                </Form.Group>
              )}

              <Button
                style={{
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginTop: "15px",
                }}
                elevation={3}
                className="w-100"
                variant="primary"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : null}
                {isEdit ? "Modify" : "Create"} User
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </Grid>
  );
};

export default UserFragment;
